<template>
  <img
    :src="nameAndBadgeUrl"
    id="nr-name-and-badge"
    alt="CivicPlus NextRequest"
    class="name-and-badge"
  />
</template>

<script>
import nameAndBadgeUrl from 'src/../images/name-and-badge.svg?url'

export default {
  name: 'NameAndBadge',
  data() {
    return {
      nameAndBadgeUrl
    }
  }
}
</script>

<style scoped>
.name-and-badge {
  height: 1rem;
  width: auto;
}
</style>
